import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (param) {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: ``,
    name: 'PARAM_UPDATE_STATISTIC_DETAIL',
    method: 'GET',
  });

  const fetchData = function () {
    if (param) {
      let url = '/api/params_update/detail';
      Object.keys(param).forEach((key, index) => {
        if (index === 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += `${key}=${param[key]}`;
      });
      exec(url);
    }
  };
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);

  return [isRequestSuccessed, data || [], fetchData];
});
